import React, { useState, useEffect } from 'react';
import { Package, Edit2, PlusCircle, ArrowLeft, Trash2, Wrench, FileDown, ArrowUpDown, History, X, ToggleLeft, ToggleRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from './config';

function TupYonetimi({ user }) {
    const [tupler, setTupler] = useState([]);
    const [firmalar, setFirmalar] = useState([]);
    const [formOpen, setFormOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const [searchSeri, setSearchSeri] = useState('');
    const [searchKonum, setSearchKonum] = useState('');
    const [selectedFirma, setSelectedFirma] = useState('');
    const [showPasif, setShowPasif] = useState(false);

    const [tupTipleri, setTupTipleri] = useState([]);
    const [agirliklar, setAgirliklar] = useState([]);

    const [historyModal, setHistoryModal] = useState(false);
    const [selectedTupForHistory, setSelectedTupForHistory] = useState(null);
    const [tupHistory, setTupHistory] = useState([]);

    const isMusteriOnly = user?.rol === 'Müşteri';
    const canEdit = user?.rol === 'Admin' || user?.rol === 'User';
    const canViewHistory = user?.rol === 'Admin';

    const today = new Date().toISOString().split('T')[0];
    const nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0];

    const [formData, setFormData] = useState({
        firma_id: isMusteriOnly ? user.firma_id : '',
        seri_no: '',
        tup_tipi: 'KKT',
        agirlik: '6',
        konum: '',
        son_bakim_tarihi: today,
        bir_sonraki_bakim_tarihi: nextYear,
        Durum: 'Aktif'
    });

    useEffect(() => {
        fetchTupler();
        if (!isMusteriOnly) fetchFirmalar();
        fetchTupTipleri();
        fetchAgirliklar();
    }, [searchSeri, searchKonum, selectedFirma]);

    const fetchTupTipleri = async () => {
        try {
            const res = await api.get('/api/tup-tipleri');
            setTupTipleri(res.data);
        } catch (err) {
            console.error('Tüp tipleri yüklenemedi:', err);
        }
    };

    const fetchAgirliklar = async () => {
        try {
            const res = await api.get('/api/agirliklar');
            setAgirliklar(res.data);
        } catch (err) {
            console.error('Ağırlıklar yüklenemedi:', err);
        }
    };

    const fetchTupler = async () => {
        const firmaId = isMusteriOnly ? user.firma_id : 1;
        const params = {
            search_seri: searchSeri,
            search_konum: searchKonum,
            selected_firma: isMusteriOnly ? user.firma_id : selectedFirma
        };
        const res = await api.get(`/api/tupler/${firmaId}`, { params });
        setTupler(res.data);
    };

    const fetchFirmalar = async () => {
        const res = await api.get('/api/firmalar');
        setFirmalar(res.data);
    };

    const handlePDFDownload = async () => {
        try {
            const firmaId = isMusteriOnly ? user.firma_id : (selectedFirma || 0);
            const res = await api.get('/api/rapor/tupler', {
                params: { firma_id: firmaId, pasif_dahil: showPasif },
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `tupler_rapor_${new Date().toISOString().split('T')[0]}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            alert('PDF indirme başarısız: ' + (err.response?.data?.detail || 'Bilinmeyen hata'));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.firma_id) return alert("Lütfen bir firma seçin!");

        const payload = {
            ...formData,
            firma_id: parseInt(formData.firma_id)
        };

        try {
            if (editId) {
                await api.put(`/api/tupler/${editId}`, payload);
                alert("Tüp güncellendi!");
            } else {
                await api.post('/api/tupler', payload);
                alert("Tüp eklendi!");
            }
            resetForm();
            fetchTupler();
        } catch (err) {
            console.error(err);
            alert("İşlem başarısız!");
        }
    };

    const resetForm = () => {
        setFormData({
            firma_id: isMusteriOnly ? user.firma_id : '',
            seri_no: '',
            tup_tipi: 'KKT',
            agirlik: '6',
            konum: '',
            son_bakim_tarihi: today,
            bir_sonraki_bakim_tarihi: nextYear,
            Durum: 'Aktif'
        });
        setFormOpen(false);
        setEditId(null);
    };

    const handleEdit = (tup) => {
        setEditId(tup.tup_id);
        setFormData({
            firma_id: tup.firma_id,
            seri_no: tup.seri_no,
            tup_tipi: tup.tup_tipi,
            agirlik: tup.agirlik,
            konum: tup.konum,
            son_bakim_tarihi: tup.son_bakim_tarihi || today,
            bir_sonraki_bakim_tarihi: tup.bir_sonraki_bakim_tarihi || nextYear
        });
        setFormOpen(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Bu tüpü pasif yapmak istediğinize emin misiniz?")) return;
        try {
            await api.delete(`/api/tupler/${id}`);
            alert("Tüp pasif yapıldı!");
            fetchTupler();
        } catch {
            alert("İşlem başarısız!");
        }
    };

    const handleToggleDurum = async (tup) => {
        const yeniDurum = tup.Durum === 'Aktif' ? 'Pasif' : 'Aktif';
        if (!window.confirm(`Bu tüpü ${yeniDurum} yapmak istediğinize emin misiniz?`)) return;
        try {
            await api.patch(`/api/tupler/${tup.tup_id}/durum`);
            if (yeniDurum === 'Pasif') setShowPasif(true);
            fetchTupler();
        } catch { alert("Durum değiştirme başarısız!"); }
    };

    const handleBakim = async (id) => {
        if (!window.confirm("Bu tüp için bakım yapıldı olarak işaretlensin mi?")) return;
        try {
            await api.patch(`/api/tupler/${id}/bakim`);
            alert("Bakım kaydedildi!");
            fetchTupler();
        } catch { alert("İşlem başarısız!"); }
    };

    const handleShowHistory = async (tup) => {
        setSelectedTupForHistory(tup);
        setHistoryModal(true);
        try {
            const res = await api.get(`/api/hareketler/tup/${tup.tup_id}`);
            setTupHistory(res.data);
        } catch (err) {
            console.error('Geçmiş yüklenemedi:', err);
            setTupHistory([]);
        }
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedTupler = [...tupler].sort((a, b) => {
        if (!sortConfig.key) return 0;
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];
        if (aVal == null) aVal = '';
        if (bVal == null) bVal = '';
        if (typeof aVal === 'string') aVal = aVal.toLowerCase();
        if (typeof bVal === 'string') bVal = bVal.toLowerCase();
        if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    // Pasif tüpleri filtrele (showPasif false ise)
    const filteredTupler = showPasif ? sortedTupler : sortedTupler.filter(t => t.Durum !== 'Pasif');

    const SortableHeader = ({ label, sortKey }) => (
        <th style={{ ...p12, cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort(sortKey)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {label}
                <ArrowUpDown size={14} color={sortConfig.key === sortKey ? '#3b82f6' : '#9ca3af'} />
            </div>
        </th>
    );

    return (
        <div style={{ padding: '20px', backgroundColor: '#f3f4f6', minHeight: '100vh', fontFamily: 'sans-serif' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

                <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '20px', color: '#3b82f6', textDecoration: 'none' }}>
                    <ArrowLeft size={18} /> Ana Sayfa
                </Link>

                <div style={panelStyle}>
                    <h2 style={{ marginTop: 0 }}>
                        <Package size={24} style={{ verticalAlign: 'middle', marginRight: '10px' }} />
                        {isMusteriOnly ? "Firmamın Tüpleri" : "Tüp Yönetimi"}
                    </h2>

                    {/* FİLTRELEME PANELİ */}
                    <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap', padding: '15px', backgroundColor: '#f9fafb', borderRadius: '10px' }}>
                        {!isMusteriOnly && (
                            <div style={{ flex: '1', minWidth: '150px' }}>
                                <label style={labelStyle}>Firma</label>
                                <select value={selectedFirma} onChange={e => setSelectedFirma(e.target.value)} style={inputBase}>
                                    <option value="">Tümü</option>
                                    {firmalar.map(f => <option key={f.firma_id} value={f.firma_id}>{f.firma_adi}</option>)}
                                </select>
                            </div>
                        )}
                        <div style={{ flex: '1', minWidth: '150px' }}>
                            <label style={labelStyle}>Seri No</label>
                            <input
                                type="text"
                                placeholder="Seri no ara..."
                                value={searchSeri}
                                onChange={e => setSearchSeri(e.target.value)}
                                style={inputBase}
                            />
                        </div>
                        <div style={{ flex: '1', minWidth: '150px' }}>
                            <label style={labelStyle}>Konum</label>
                            <input
                                type="text"
                                placeholder="Konum ara..."
                                value={searchKonum}
                                onChange={e => setSearchKonum(e.target.value)}
                                style={inputBase}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px' }}>
                            <button onClick={() => { setSearchSeri(''); setSearchKonum(''); setSelectedFirma(''); }} style={{ ...saveBtn, backgroundColor: '#6b7280' }}>
                                Temizle
                            </button>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px', backgroundColor: '#f3f4f6', borderRadius: '8px', cursor: 'pointer' }}>
                                <input
                                    type="checkbox"
                                    checked={showPasif}
                                    onChange={(e) => setShowPasif(e.target.checked)}
                                    style={{ cursor: 'pointer' }}
                                />
                                <span style={{ fontSize: '14px', color: '#374151' }}>Pasif Tüpleri Göster</span>
                            </label>
                            <button
                                onClick={handlePDFDownload}
                                style={{ ...saveBtn, backgroundColor: '#10b981' }}
                            >
                                <FileDown size={16} style={{ marginRight: '5px' }} /> PDF
                            </button>
                        </div>
                    </div>

                    {canEdit && (
                        <button onClick={() => { setFormOpen(!formOpen); if (formOpen) resetForm(); }} style={{ ...saveBtn, backgroundColor: '#3b82f6', marginBottom: '20px' }}>
                            <PlusCircle size={18} style={{ marginRight: '8px' }} />
                            {formOpen ? "İptal" : "Yeni Tüp Ekle"}
                        </button>
                    )}

                    {formOpen && canEdit && (
                        <form onSubmit={handleSubmit} style={{ marginBottom: '20px', padding: '20px', backgroundColor: '#f9fafb', borderRadius: '12px' }}>
                            <h4 style={{ marginTop: 0 }}>{editId ? "Tüp Düzenle" : "Yeni Tüp"}</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                                <div>
                                    <label style={labelStyle}>Firma</label>
                                    {isMusteriOnly ? (
                                        <input type="text" value="Kendi Firmanız" style={inputBase} disabled />
                                    ) : (
                                        <select value={formData.firma_id} onChange={e => setFormData({ ...formData, firma_id: e.target.value })} style={inputBase} required>
                                            <option value="">Firma Seç...</option>
                                            {firmalar.map(f => <option key={f.firma_id} value={f.firma_id}>{f.firma_adi}</option>)}
                                        </select>
                                    )}
                                </div>
                                <div>
                                    <label style={labelStyle}>Seri No</label>
                                    <input type="text" value={formData.seri_no} onChange={e => setFormData({ ...formData, seri_no: e.target.value })} style={inputBase} required />
                                </div>
                                <div>
                                    <label style={labelStyle}>Tüp Tipi</label>
                                    <select value={formData.tup_tipi} onChange={e => setFormData({ ...formData, tup_tipi: e.target.value })} style={inputBase}>
                                        {tupTipleri.map(t => <option key={t} value={t}>{t}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label style={labelStyle}>Ağırlık (kg)</label>
                                    <select value={formData.agirlik} onChange={e => setFormData({ ...formData, agirlik: e.target.value })} style={inputBase}>
                                        {agirliklar.map(a => <option key={a} value={a}>{a} kg</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label style={labelStyle}>Konum</label>
                                    <input type="text" value={formData.konum} onChange={e => setFormData({ ...formData, konum: e.target.value })} style={inputBase} required />
                                </div>
                                <div>
                                    <label style={labelStyle}>Son Bakım Tarihi</label>
                                    <input type="date" value={formData.son_bakim_tarihi} onChange={e => setFormData({ ...formData, son_bakim_tarihi: e.target.value })} style={inputBase} required />
                                </div>
                                <div>
                                    <label style={labelStyle}>Gelecek Bakım Tarihi</label>
                                    <input type="date" value={formData.bir_sonraki_bakim_tarihi} onChange={e => setFormData({ ...formData, bir_sonraki_bakim_tarihi: e.target.value })} style={inputBase} required />
                                </div>
                                <div>
                                    <label style={labelStyle}>Durum</label>
                                    <select value={formData.Durum} onChange={e => setFormData({ ...formData, Durum: e.target.value })} style={inputBase}>
                                        <option value="Aktif">Aktif</option>
                                        <option value="Pasif">Pasif</option>
                                        <option value="Beklemede">Beklemede</option>
                                    </select>
                                </div>
                            </div>
                            <button type="submit" style={{ ...saveBtn, backgroundColor: editId ? '#f59e0b' : '#10b981', marginTop: '20px' }}>
                                {editId ? "Güncelle" : "Kaydet"}
                            </button>
                        </form>
                    )}

                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
                            <thead>
                                <tr style={{ textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>
                                    <SortableHeader label="ID" sortKey="tup_id" />
                                    {!isMusteriOnly && <SortableHeader label="Firma" sortKey="firma_adi" />}
                                    <SortableHeader label="Seri No" sortKey="seri_no" />
                                    <SortableHeader label="Tüp Tipi" sortKey="tup_tipi" />
                                    <SortableHeader label="Ağırlık" sortKey="agirlik" />
                                    <SortableHeader label="Konum" sortKey="konum" />
                                    <SortableHeader label="Son Bakım" sortKey="son_bakim_tarihi" />
                                    <SortableHeader label="Gelecek Bakım" sortKey="bir_sonraki_bakim_tarihi" />
                                    <SortableHeader label="Durum" sortKey="Durum" />
                                    {canEdit && <th style={p12}>İşlemler</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredTupler.map(t => {
                                    const today = new Date();
                                    const bakimTarihi = t.bir_sonraki_bakim_tarihi ? new Date(t.bir_sonraki_bakim_tarihi) : null;
                                    const kalanGun = bakimTarihi ? Math.ceil((bakimTarihi - today) / (1000 * 60 * 60 * 24)) : null;

                                    let rowStyle = { borderBottom: '1px solid #f3f4f6', opacity: t.Durum === 'Pasif' ? 0.5 : 1 };
                                    if (kalanGun !== null) {
                                        if (kalanGun < 0) rowStyle = { ...rowStyle, backgroundColor: '#fef2f2' };
                                        else if (kalanGun <= 30) rowStyle = { ...rowStyle, backgroundColor: '#fffbeb' };
                                    }

                                    return (
                                        <tr key={t.tup_id} style={rowStyle}>
                                            <td style={p12}>{t.tup_id}</td>
                                            {!isMusteriOnly && <td style={p12}>{t.firma_adi}</td>}
                                            <td style={p12}><strong>{t.seri_no}</strong></td>
                                            <td style={p12}><span style={{ padding: '4px 10px', borderRadius: '12px', backgroundColor: '#dbeafe', fontSize: '12px' }}>{t.tup_tipi}</span></td>
                                            <td style={p12}>{t.agirlik} kg</td>
                                            <td style={p12}>{t.konum}</td>
                                            <td style={p12}>{t.son_bakim_tarihi}</td>
                                            <td style={p12}>
                                                {t.bir_sonraki_bakim_tarihi}
                                                {kalanGun !== null && kalanGun < 0 && <span style={{ marginLeft: '8px', color: '#dc2626', fontSize: '11px' }}>⚠️ Gecikmiş</span>}
                                                {kalanGun !== null && kalanGun >= 0 && kalanGun <= 30 && <span style={{ marginLeft: '8px', color: '#d97706', fontSize: '11px' }}>⏰ {kalanGun} gün</span>}
                                            </td>
                                            <td style={p12}>
                                                {canEdit ? (
                                                    <button onClick={() => handleToggleDurum(t)} style={{ ...iconBtn, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                        {t.Durum === 'Aktif' ? (
                                                            <><ToggleRight size={22} color="#10b981" /> <span style={{ color: '#10b981', fontSize: '12px' }}>Aktif</span></>
                                                        ) : (
                                                            <><ToggleLeft size={22} color="#ef4444" /> <span style={{ color: '#ef4444', fontSize: '12px' }}>Pasif</span></>
                                                        )}
                                                    </button>
                                                ) : (
                                                    <span style={{ fontSize: '12px', color: t.Durum === 'Aktif' ? '#10b981' : '#ef4444' }}>{t.Durum}</span>
                                                )}
                                            </td>
                                            {(canViewHistory || canEdit) && (
                                                <td style={p12}>
                                                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                                        {canViewHistory && <button onClick={() => handleShowHistory(t)} style={iconBtn} title="Geçmiş"><History size={18} color="#8b5cf6" /></button>}
                                                        {canEdit && <button onClick={() => handleBakim(t.tup_id)} style={iconBtn} title="Bakım Yapıldı"><Wrench size={18} color="#10b981" /></button>}
                                                        {canEdit && <button onClick={() => handleEdit(t)} style={iconBtn} title="Düzenle"><Edit2 size={18} color="#f59e0b" /></button>}
                                                        {canViewHistory && <button onClick={() => handleDelete(t.tup_id)} style={{ ...iconBtn, marginLeft: '8px' }} title="Pasif Yap"><Trash2 size={18} color="#ef4444" /></button>}
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* GEÇMIŞ MODAL */}
                {historyModal && selectedTupForHistory && (
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                        <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '12px', width: '900px', maxWidth: '95%', maxHeight: '85vh', overflow: 'auto' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', position: 'sticky', top: 0, backgroundColor: 'white', paddingBottom: '15px', borderBottom: '2px solid #e5e7eb' }}>
                                <div>
                                    <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <History size={24} color="#8b5cf6" />
                                        Tüp Geçmişi
                                    </h3>
                                    <p style={{ margin: '5px 0 0', color: '#6b7280', fontSize: '14px' }}>
                                        Seri No: <strong>{selectedTupForHistory.seri_no}</strong> | Konum: <strong>{selectedTupForHistory.konum}</strong>
                                    </p>
                                </div>
                                <button onClick={() => setHistoryModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                    <X size={24} />
                                </button>
                            </div>

                            {tupHistory.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                                    Bu tüp için henüz hareket kaydı bulunmuyor.
                                </div>
                            ) : (
                                <div>
                                    <div style={{ marginBottom: '15px', padding: '12px', backgroundColor: '#f9fafb', borderRadius: '8px' }}>
                                        <strong>Toplam {tupHistory.length} hareket</strong>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                        {tupHistory.map((h, index) => (
                                            <div key={h.hareket_id} style={{
                                                padding: '15px',
                                                borderRadius: '8px',
                                                border: '1px solid #e5e7eb',
                                                backgroundColor: index === 0 ? '#fef3c7' : 'white'
                                            }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '10px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                        <span style={{
                                                            backgroundColor: h.islem_tipi === 'Ekleme' ? '#10b98120' :
                                                                           h.islem_tipi === 'Güncelleme' ? '#3b82f620' :
                                                                           h.islem_tipi === 'Pasif' ? '#ef444420' : '#f59e0b20',
                                                            color: h.islem_tipi === 'Ekleme' ? '#10b981' :
                                                                   h.islem_tipi === 'Güncelleme' ? '#3b82f6' :
                                                                   h.islem_tipi === 'Pasif' ? '#ef4444' : '#f59e0b',
                                                            padding: '4px 12px',
                                                            borderRadius: '12px',
                                                            fontSize: '13px',
                                                            fontWeight: 'bold'
                                                        }}>
                                                            {h.islem_tipi}
                                                        </span>
                                                        {index === 0 && <span style={{ fontSize: '12px', color: '#f59e0b', fontWeight: 'bold' }}>En Son</span>}
                                                    </div>
                                                    <span style={{ fontSize: '13px', color: '#6b7280' }}>
                                                        {new Date(h.islem_tarihi).toLocaleString('tr-TR')}
                                                    </span>
                                                </div>

                                                <div style={{ fontSize: '13px', marginBottom: '8px' }}>
                                                    <strong>Kullanıcı:</strong> {h.kullanici_email || <span style={{ color: '#9ca3af' }}>Sistem</span>}
                                                </div>

                                                {h.aciklama && (
                                                    <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px' }}>
                                                        {h.aciklama}
                                                    </div>
                                                )}

                                                {h.eski_deger && (
                                                    <details style={{ fontSize: '12px', marginTop: '10px' }}>
                                                        <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '5px' }}>Eski Değer</summary>
                                                        <pre style={{ backgroundColor: '#f9fafb', padding: '10px', borderRadius: '6px', overflow: 'auto', margin: '5px 0' }}>
                                                            {JSON.stringify(JSON.parse(h.eski_deger), null, 2)}
                                                        </pre>
                                                    </details>
                                                )}

                                                {h.yeni_deger && (
                                                    <details style={{ fontSize: '12px', marginTop: '8px' }}>
                                                        <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '5px' }}>Yeni Değer</summary>
                                                        <pre style={{ backgroundColor: '#f0fdf4', padding: '10px', borderRadius: '6px', overflow: 'auto', margin: '5px 0' }}>
                                                            {JSON.stringify(JSON.parse(h.yeni_deger), null, 2)}
                                                        </pre>
                                                    </details>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

const panelStyle = { backgroundColor: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
const inputBase = { padding: '12px', borderRadius: '8px', border: '1px solid #ddd', outline: 'none', fontSize: '14px', width: '100%', boxSizing: 'border-box' };
const labelStyle = { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#374151' };
const saveBtn = { color: 'white', border: 'none', borderRadius: '8px', padding: '12px 20px', cursor: 'pointer', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center' };
const iconBtn = { border: 'none', background: 'none', cursor: 'pointer', marginRight: '8px' };
const p12 = { padding: '12px' };

export default TupYonetimi;
